export default __webpack_public_path__ + "elva@2x.067321d4.jpg";